import * as React from 'react';
import { chunk } from 'lodash-es';
import { withStyles, WithStyles, createStyles } from '@material-ui/core';

import Link from 'ha/ui/next/Link';
import Grid from 'ha/ui/next/Grid';
import units from 'ha/theme/units';
import { Suggestion as SuggestionsType } from '../../types';

export const styles = createStyles({
  card: {
    fontSize: units.rem('0.9'),
    lineHeight: units.rem('2'),
  },
  cityName: {
    fontWeight: 'bold',
  },
});

interface Props {
  list: SuggestionsType[];
  columnCount: number;
}

export const Suggestions: React.SFC<Props & WithStyles<typeof styles>> = ({
  list,
  columnCount,
  classes,
}) => {
  const chunks = chunk(list, Math.ceil(list.length / columnCount));

  return (
    <React.Fragment>
      {chunks.map((item, index) => (
        <Grid
          item
          xs={2}
          key={index}
          className={classes.card}
          data-test-locator="Suggestion Group"
        >
          {item.map(({ searchUrl, cityLocalized, countryLocalized }) => (
            <div key={searchUrl} data-test-locator="Suggestion Item">
              <Link
                to={searchUrl}
                kind="hover-underline"
                title={`${cityLocalized}, ${countryLocalized}`}
              >
                <span className={classes.cityName}>{cityLocalized}</span>
                <span>, {countryLocalized}</span>
              </Link>
            </div>
          ))}
        </Grid>
      ))}
    </React.Fragment>
  );
};

export default withStyles(styles)(Suggestions);
